import { colors } from '~/layout';
import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  background-color: ${colors.white};
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;

  .addContact {
    position: absolute;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
  }

  .rowContacts {
    min-height: 52px;
    margin-bottom: 7px;
  }

  }
`;

export const Block = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const TitleContent = lib.styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  align-items: center;
  left: 0;
  margin-left: 70px;

  svg {
    margin-top: 5px;
    width: 20px;
    height: 20px;
  }

  .icon-arrow-left {
    cursor: pointer;
    svg {
      width: 18px;
      height: 18px;
    }
  }

  span {
    margin-left: 15px;
    margin-right: 8px;
    font-size: 16px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 155px;
  }
`;

export const Right = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-right: 10px;

  .icon-actions {
    padding: 0px;
    div {
      width: 32px;
      max-width: 32px;
      height: 32px;
      max-height: 32px;
    }
  }
`;

export const SearchBox = lib.styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  left: 70px
  width: 300px;
  height: 33px;
  border-radius: 7px;
  border: 1px solid ${colors.lightGray17};
  outline: none;
  padding-left: 10px;
  text-align: center;
  color: ${colors.darkGray11};
  background-color: ${colors.white};
`;

export const SearchInput = lib.styled.input`
  width: 265px;
  outline: none;
  box-shadow: none;
  border: none;
  text-align: center;
  color: ${colors.darkGray11};
  letter-spacing: 0.5px;
  font-size: 14px;

  &::placeholder {
    text-align: center;
    font-style: italic;
    font-family: Nunito;
    font-size: 14px;
    letter-spacing: 0.5px;
  }
`;

export const ClearSearchBtn = lib.styled.div`
  display: flex;
  aign-items: center;
  position: absolute;
  font-size: 18px;
  right: 10px;
  cursor: pointer;
  color: ${colors.darkGray11};
`;

export const Loader = lib.styled.div`
  margin-top: 20px;
`;
